import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Calendar } from "react-calendar";
import "react-calendar/dist/Calendar.css";
import calender from "../../../assets/calender.png";
import calender_dark from "../../../assets/calender_dark.png";
import { useCreateLeagueMatchStore } from "../../../store/StoreContext";
import { REQUEST_PLAYER_DATES_LIST_COUNT } from "../../../utils/constants";
import { DateContainer } from "./dateContainer/DateContainer";
import { Colors } from "../../../utils/colors";
import { TCText } from "../../../components/tcText/TCText";

type props = {};

export const DatesList: React.FC<props> = observer(() => {
  const createLeagueMatchStore = useCreateLeagueMatchStore();
  const [showCalendar, setShowCalendar] = useState(false);

  useEffect(() => {
    // Initialize dates if needed
    if (createLeagueMatchStore.nextSixDays.length === 0) {
      createLeagueMatchStore.generateNextSixDays();
    }
  }, [createLeagueMatchStore]);

  // Updated function to handle the correct type from react-calendar
  const handleCalendarSelect = (value: Date | null) => {
    if (value !== null) {
      const selectedDate = value;
      createLeagueMatchStore.addCustomDate(selectedDate);
      setShowCalendar(false);
    }
  };
  const isCalendarSelected =
    createLeagueMatchStore.nextSixDays.length >
      REQUEST_PLAYER_DATES_LIST_COUNT &&
    createLeagueMatchStore.selectedDate?.fullDate ===
      createLeagueMatchStore.nextSixDays[REQUEST_PLAYER_DATES_LIST_COUNT]
        .fullDate;

  return (
    <div style={{ marginTop: 15 }}>
      <div
        style={{
          display: "flex",
          overflowX: "auto",
          gap: "10px", // Adds spacing between items
          scrollbarWidth: "none", // Hides scrollbar in Firefox
          msOverflowStyle: "none", // Hides scrollbar in IE
        }}>
        {createLeagueMatchStore.nextSixDays
          .slice(0, REQUEST_PLAYER_DATES_LIST_COUNT)
          .map((dateInfo, index) => (
            <DateContainer key={index} dateInfo={dateInfo} />
          ))}

        {/* Custom date option */}
        <div
          onClick={() => setShowCalendar(!showCalendar)}
          style={{
            minWidth: 56,
            height: 64,
            borderRadius: 16,
            backgroundColor: isCalendarSelected
              ? Colors.green
              : Colors.lightGreyBackground,
            color: "white",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}>
          <img
            src={isCalendarSelected ? calender : calender_dark}
            alt="My"
            width={isCalendarSelected ? 20 : 35}
            height={isCalendarSelected ? 21 : 35}
          />
          {isCalendarSelected && (
            <>
              <TCText
                style={{ fontWeight: 600, fontSize: 10, marginTop: 2 }}
                value={`${createLeagueMatchStore.nextSixDays[REQUEST_PLAYER_DATES_LIST_COUNT].day} ${createLeagueMatchStore.nextSixDays[REQUEST_PLAYER_DATES_LIST_COUNT].date}`}
              />

              <div style={{ fontWeight: 500, fontSize: 8 }}>
                {
                  createLeagueMatchStore.nextSixDays[
                    REQUEST_PLAYER_DATES_LIST_COUNT
                  ].month
                }
              </div>
            </>
          )}
        </div>
      </div>

      {/* Calendar popup */}
      {showCalendar && (
        <div
          style={{
            position: "absolute",
            zIndex: 1000,
            backgroundColor: "white",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            borderRadius: "8px",
            marginTop: "10px",
          }}>
          <Calendar
            onChange={(value) => {
              handleCalendarSelect(value as Date | null);
            }}
            defaultValue={createLeagueMatchStore.selectedDate?.fullDate}
            minDate={createLeagueMatchStore.getCalenderMinDate()}
            maxDate={new Date(Date.now() + 90 * 24 * 60 * 60 * 1000)} // 90 days from now
          />
        </div>
      )}
    </div>
  );
});
